import React, { Component } from 'react';

/**
 * AgentControlButtons — pure UI
 *
 * Props:
 *  - agentRunning   : boolean
 *  - agentPaused    : boolean
 *  - agentDone      : boolean
 *  - agentError     : string | null
 *  - canResume      : boolean
 *  - canCancel      : boolean
 *  - onStart        : () => void
 *  - onPause        : () => void
 *  - onCancel       : () => void
 *  - onResume       : () => void
 *  - onStop         : () => void
 *  - onReset        : () => void
 */
export default class AgentControlButtons extends Component {
  render() {
    const {
      agentRunning,
      agentPaused,
      agentDone,
      agentError,
      canResume,
      canCancel,
      startLabel,
      doneLabel,
      onStart,
      onPause,
      onCancel,
      onResume,
      onStop,
      onReset,
    } = this.props;

    return (
      <div className="agent-control-buttons-inline">
        {agentError && (
          <div className="agent-error agent-error--inline">
            {agentError}
          </div>
        )}

        {/* Show Resume button when agent is paused or can be resumed */}
        {canResume && !agentRunning && (
          <div style={{ display: 'flex', gap: '6px' }}>
            <button
              type="button"
              className="agent-run-btn secondary agent-run-btn--compact"
              onClick={onResume}
            >
              {agentPaused ? '▶ Resume' : 'Resume'}
            </button>
            <button
              type="button"
              className="agent-run-btn secondary agent-run-btn--compact"
              onClick={onReset}
            >
              ↻ Restart
            </button>
          </div>
        )}

        {/* Main action button - changes based on state */}
        {!canResume && (
          <div style={{ display: 'flex', gap: '6px' }}>
            <button
              type="button"
              className={`agent-run-btn primary agent-run-btn--compact ${agentRunning ? 'is-running' : ''} ${agentDone ? 'is-done' : ''}`}
              onClick={agentRunning ? onPause : onStart}
              aria-pressed={agentRunning}
            >
              {agentRunning ? '⏸ Pause' : agentDone ? `▶ ${doneLabel || 'Run'}` : `▶ ${startLabel || 'Run'}`}
            </button>
            {agentDone && !agentRunning && (
              <button
                type="button"
                className="agent-run-btn secondary agent-run-btn--compact"
                onClick={onReset}
              >
                ↻ Restart
              </button>
            )}
          </div>
        )}

        {/* Show both pause and stop when running and not paused */}
        {agentRunning && !agentPaused && canResume && (
          <div style={{ display: 'flex', gap: '6px' }}>
            <button
              type="button"
              className="agent-run-btn secondary agent-run-btn--compact"
              onClick={onPause}
            >
              ⏸ Pause
            </button>
            <button
              type="button"
              className="agent-run-btn secondary agent-run-btn--compact"
              onClick={onStop}
            >
              ⏹ Stop
            </button>
          </div>
        )}

        <button
          type="button"
          className="agent-run-btn secondary agent-run-btn--compact"
          onClick={onCancel}
          disabled={!canCancel}
          title={canCancel ? 'Cancel active execution' : 'No active execution'}
        >
          ✕ Cancel
        </button>
      </div>
    );
  }
}
